import { gql } from '@apollo/client';

export const GET_UPCOMING_SAVED_FLYERS = gql`
query getUpcomingSavedFlyers {
  flyers: getUpcomingSavedFlyers {
    title
    flyerId
    frontImageUrl
    districtId
    startDate
    criticalDate
    activities
    schools {
      schoolId
      name
      branding {
        logoAlt
        logoLinkUrl
        logoUrl
      }
    }
  }
}
`;
